<ng-container *ngIf="twoFactorAuthService.loading; else verifyModal">
  <p [attr.data-qa]="'two-factor-verify-modal-loading'" class="text-center pt-3 pb-3 h2">Please Wait...<span class="fa fa-spinner fa-pulse fa-fw"></span></p>
</ng-container>
<ng-template #verifyModal>
<div class="container-fluid white-space-wrap text-left pt-2 verify-code" [attr.data-qa]="'two-factor-verify-modal-container'">
    <div class="row" id="product-container">
      <div class="col-xs-12 col-sm-12">
        <h2 class="pl-2 pr-2 page-title mb-0 msg-title" [attr.data-qa]="'two-factor-verify-modal-title'">Verification Code</h2>
      </div>
    </div>
    <div class="row mt-4 msg-body" [hidden]="twoFactorAuthService.success.length === 0 && twoFactorAuthService.error.length === 0 && twoFactorAuthService.attemptCounter === 3">
      <div class="col-xs-11 p-0 ml-3 mr-3" [attr.data-qa]="'two-factor-verify-modal-alertDiv'" [attr.tabindex]="0" id="errorDiv" #errorDiv>
        <div *ngIf="twoFactorAuthService.success.length > 0">
          <div class="alert alert-success" [attr.data-qa]="'two-factor-verify-modal-successmsg'" *ngFor="let pass of twoFactorAuthService.success">
            <h3 class="h4">Successful:</h3>
            <p>{{pass.message || 'Your changes have been saved.'}}</p>
          </div>
        </div>
        <div *ngIf="twoFactorAuthService.error.length > 0">
          <div class="alert alert-danger" *ngFor="let err of twoFactorAuthService.error" [attr.data-qa]="'two-factor-verify-modal-errormsg'">
            <h3 class="h4">Error:</h3>
            <p>{{err.message || 'There is an error processing your request at this time. Please try again later.'}}</p>
          </div>
        </div>
        <div *ngIf="twoFactorAuthService.attemptCounter < 3" [attr.data-qa]="'two-factor-verify-modal-alert-note'">
          <div class="alert alert-info">
            <h3 class="h4">Note:</h3>
            <p>You have {{twoFactorAuthService.attemptCounter}} {{twoFactorAuthService.attemptCounter > 1 ? 'attempts': 'attempt'}} remaining.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4 msg-body" *ngIf="showForm" [attr.data-qa]="'two-factor-verify-modal-form'">
      <div class="col-xs-11">
        <div class="card border-0 bg-white pl-2 pr-2 text-dark">
          <div class="d-flex align-items-start mb-3 pb-2 border-bottom border-light">
            <div>
              <p class="text-left" [attr.data-qa]="'two-factor-verify-p'">To continue with your action, please enter the verification code we sent to: 
                <strong *ngIf="payloadData.contact.type === 'EMAIL'" [attr.data-qa]="'two-factor-verify-email'">{{payloadData.hrtContactValue | mask:'true':null:null:'email' }}</strong>
                <strong *ngIf="payloadData.contact.type === 'PHONE'" [attr.data-qa]="'two-factor-verify-phone'">{{payloadData.hrtContactValue | mask:'true':null:null:'phone' }}</strong>
              </p>
            </div>
          </div>
          <div class="row mt-3 mb-3">
            <div class="col-xs-12 col-md-6">
              <form [formGroup]="verifyCodeFormGroup" novalidate>
                <div class="form-group" [ngClass]="{'has-error': verifyCodeFormGroup.controls['code']?.invalid && verifyCodeFormGroup.controls['code']?.touched}">
                  <label for="code" class="control-label">
                    Verification code
                  </label>
                  <input type="text" [attr.data-qa]="'two-factor-verify-input'" formControlName="code" #inputCode [attr.aria-invalid]="verifyCodeFormGroup.controls['code']?.invalid && verifyCodeFormGroup.controls['code']?.touched ? true : false" aria-required="true" aria-describedby="verifyCodeError" id="code" class="form-control" />
                  <div class="help-block" id="verifyCodeError" *ngIf="verifyCodeFormGroup.controls['code']?.invalid && verifyCodeFormGroup.controls['code']?.touched">
                    <span class="sr-only">Error:</span>
                    <span *ngIf="verifyCodeFormGroup.controls['code']?.errors?.required">
                      Verification code field is required
                    </span>
                  </div>
                </div>
                <button type="button" class="btn btn-link pl-0 resend-code" [attr.data-qa]="'two-factor-verify-resend'" (click)="resendACode(true)">Resend code</button>
                <div class="row mt-3">
                  <div class="col-xs-9">
                    <button type="submit" class="btn btn-primary" (click)="onSubmit()" [attr.data-qa]="'two-factor-verify-p'"[attr.data-qa]="'two-factor-verify-coontinue-btn'" [disabled]="(!verifyCodeFormGroup.valid || !verifyCodeFormGroup.dirty) || twoFactorAuthService.loading">
                      Continue
                      <span class="fa fa-spinner fa-spin" *ngIf="twoFactorAuthService.loading"></span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
</ng-template>